import Tocqueville from '../images/Tocqueville.jpg';

function TocquevilleAlexisEmbed(){
    return (
        <>
        <img src={Tocqueville} alt="Alexis de Tocqueville Portrait" className="faithImage" />
        </>
    );
};
export default TocquevilleAlexisEmbed;